import React from 'react';
import { Footer } from '@ver-uds/react';
import uscisSeal from '../assets/icons/dhs-seal.svg';
import ssaSeal from '../assets/icons/ssa-seal.svg';
import { EveRoutes } from '..';

const EveFooter = (): JSX.Element => {
  return (
    <Footer
      primarySection={
        <Footer.Section
          leftSection={
            <Footer.Nav>
              <a href="https://www.dhs.gov/" target="_blank" rel="noopener noreferrer">
                U.S. Department of Homeland Security
              </a>
              <a href="https://www.uscis.gov/" target="_blank" rel="noopener noreferrer">
                U.S. Citizenship and Immigration Services
              </a>
            </Footer.Nav>
          }
          rightSection={
            <Footer.Nav>
              <a
                href="https://www.e-verify.gov/key-links/website-policies/accessibility"
                target="_blank"
                rel="noopener noreferrer"
              >
                Accessibility
              </a>
              <a href="https://www.uscis.gov/website-policies/plug-ins" target="_blank" rel="noopener noreferrer">
                Plug-ins
              </a>
              <a href={EveRoutes.SITEMAP} target="_blank" rel="noopener noreferrer">
                Site Map
              </a>
            </Footer.Nav>
          }
        />
      }
      secondarySection={
        <Footer.Section
          leftSection={
            <Footer.Nav>
              <a href="https://www.dhs.gov/" target="_blank" rel="noopener noreferrer">
                <img src={uscisSeal} alt="U.S. Department of Homeland Security" />
              </a>
              <a href="https://www.ssa.gov/" target="_blank" rel="noopener noreferrer">
                <img src={ssaSeal} alt="U.S. Social Security Administration" />
              </a>
            </Footer.Nav>
          }
        />
      }
    />
  );
};

export default EveFooter;
